
LoginOptionSelectionController.$inject = ['$scope', 'company', 'LoginFactory', '$state'];
export function LoginOptionSelectionController($scope, company, LoginFactory, $state) {

  $scope.optionSelected = optionSelected;
  
  init();

  function optionSelected(option) {
    LoginFactory.saveIsRememberMyChoice(company.id, $scope.isRememberMyChoice);
    $state.go('no-auth.company.login', {
      ...LoginFactory.stateParamsToPropagate(),
      selectedLoginOption: option,
    });
  }

  function init() {
    $scope.loginOptions = $state.params.loginOptions;
    $scope.isRememberMyChoice = false;
  }

}
